import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import userStoreModule from '@/store/modules/user';
import {getUserDetail, prospectList, getShopTel, getWechatAppUrl, getSupplyTel} from '@/api/miscellaneous';
import {useRouter, useRoute} from 'vue-router';
import {turnPages} from '@/hooks';
import moment from 'moment';
import config from '@/config';
import VipTag from '@/components/VipTag.vue';
import RestrictDialog from '@/components/RestrictDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'My',
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const route = useRoute();
const isShowPotential = ref(false);
const getListData = ref({
    dataType: 'all',
});

const {
    list: prospects,
    loading,
    finished,
    loadMore,
    refresh,
} = turnPages({
    api: prospectList,
    handleData: data => {
        return data.items;
    },
    params: getListData,
    loadingReturn: true,
});

const tel = ref(false);
const isShowTel = ref(false);
const restrictShow = ref(false);
const restrictCode = ref('');

const userInfo = ref({});

const getData = () => {
    getUserDetail().then((res: any) => {
        res.avatarUrl = res.avatarUrl.substring(0, 4) == 'http' ? res.avatarUrl : config.imgHost + '/' + res.avatarUrl;
        userInfo.value = res;
        const {show, dataType} = route.query;
        if (show) {
            getListData.value.dataType = (dataType as string) || 'all';
            loadMore();
            isShowPotential.value = true;
        }
    });
};
getData();

const showProspect = () => {
    const {dataType} = route.query;
    refresh({dataType: (dataType as string) || 'all'});
    isShowPotential.value = true;
};

const call = (id: string): void => {
    getShopTel({id})
        .then((res: any) => {
            tel.value = res;
            isShowTel.value = true;
        })
        .catch(e => {
            let {code,message} = e;
            if ([104, 105].includes(code)) {
                restrictCode.value = code;
                restrictShow.value = true;
            }else if(code == 403){
                alert(message);
            }
        });
};

const jumpToWechatApp = (data: any) => {
    getWechatAppUrl(data).then((res: any) => {
        location.href = JSON.parse(res).openlink;
    });
};

const toKefu = () => {
    window.location.href = 'https://work.weixin.qq.com/kfid/kfcdd1c5b9f6d099505';
};

const __returned__ = { router, route, isShowPotential, getListData, prospects, loading, finished, loadMore, refresh, tel, isShowTel, restrictShow, restrictCode, userInfo, getData, showProspect, call, jumpToWechatApp, toKefu, ref, userStoreModule, getUserDetail, prospectList, getShopTel, getWechatAppUrl, getSupplyTel, useRouter, useRoute, turnPages, moment, config, VipTag, RestrictDialog }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})